import { ReactNode } from 'react';
export function Field({ label, children, hint, error }: { label: ReactNode; children: ReactNode; hint?: ReactNode; error?: string }) {
  return (
    <label className="flex flex-col gap-1">
      <span className="text-xs font-medium muted">{label}</span>
      {children}
      {hint && <span className="text-[11px] muted">{hint}</span>}
      {error && <span className="text-[11px] text-red-600">{error}</span>}
    </label>
  );
}
